import React from 'react';
import { compose } from 'redux';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import PageQuery from 'hoc/PageQuery';
import PageView from 'hoc/PageView';
import PageTitle from 'hoc/PageTitle';
import ProtectedRoute from 'hoc/ProtectedRoute';
import PageTheme from 'hoc/PageTheme';
import { pick } from 'lodash';

import DetermineLayerContainer from 'containers/dashboards/DetermineLayerContainer';
import LabsHyperlocalContainer from 'containers/labs/LabsHyperlocalContainer';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { SideBarObjects } from 'components/pages/config/DashboardSideBarObjects';
import showGGBrandingTheme from 'helpers/showGGBrandingTheme';
import { DASHBOARD_LABS_HYPERLOCAL_VIEW, DASHBOARD_ACCESS } from 'constants/capabilities';
import { timeRanges } from 'services/config/duck';
import { getQueryParamDefForRange } from 'helpers/range';

const rvTimeRanges = pick(timeRanges, ['this-month', 'last-thirty-days', 'last-seven-days', 'custom-range']);

const LabHyperlocal = props => (
    <DashboardTemplate
        header={<HeaderContainer />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer timeRanges={rvTimeRanges} entityId={parseInt(props.match.params.entityId, 10)} />}>

        <DetermineLayerContainer
            layerTwo={LabsHyperlocalContainer}
            layerThree={LabsHyperlocalContainer}
            {...props} />
    </DashboardTemplate>
);

export default compose(
    ProtectedRoute({
        requiredCapabilities: [DASHBOARD_LABS_HYPERLOCAL_VIEW, DASHBOARD_ACCESS]
    }),
    PageTitle({ pageTitle: 'Labs - Hyperlocal Insights' }),
    PageView({
        page: 'Viewed Labs - Hyperlocal Insights',
        trackEntity: true,
    }),
    PageTheme({
        themeDefaults: { 'whitelabel.showGGBranding': showGGBrandingTheme },
    }),
    PageQuery({
        params: {
            ...getQueryParamDefForRange()
        },
        initialTruth: 'location',
    })
)(LabHyperlocal);



// WEBPACK FOOTER //
// ./src/components/pages/labs/LabHyperlocal.js